module.exports = __webpack_public_path__ + "img/colonelTroop.f0030143.png";